"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _stylitas = require("@creditas/stylitas");

var _progressBar = require("./progressBar.style");

var _Bar = require("./Bar");

var _core = require("@emotion/core");

const propTypes = {
  percentage: _propTypes.number
};
const defaultProps = {
  percentage: 0
};
const enhancer = (0, _utils.compose)(_utils.withForwardRef, (0, _utils.withDefaultProps)(propTypes, defaultProps));
const WrapperProgressBar = _stylitas.styled.div`
  ${_progressBar.progressBar};
  position: relative;

  &:before {
    content: '${({
  percentage
}) => percentage} of 100';
    position: absolute;
    right: 0;
    height: 24px;
    color: ${({
  theme
}) => theme.bTextparagraphColor};
    line-height: 24px;
    font-family: Nunito Sans;
    font-weight: 300;
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;
const ProgressBar = enhancer(({
  percentage,
  ...props
}) => {
  return (0, _core.jsx)(WrapperProgressBar, (0, _extends2.default)({}, props, {
    percentage: percentage
  }), (0, _core.jsx)(_Bar.Bar, {
    percentage: percentage
  }));
});
exports.ProgressBar = ProgressBar;